import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useState } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper as SwiperContainer, SwiperSlide } from 'swiper/react';
import useFetch from '../hooks/useFetch';
import { SET_QUESTIONS, store } from '../state/state';
import IconSprite from './IconSprite';
import Question from './Question';
import TripBuilderFooter from './TripBuilderFooter';
const url = `${window.mainSiteData.root}scenic-rim/v2/questions?`;
const TripBuilder = ({ questions }) => {
    const [loading, setLoading] = useState(false);
    const [slideIndex, setSlideIndex] = useState(0);
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const params = useMemo(() => ({
        nonce: window.mainSiteData.nonce,
        ids: questions
    }), [questions]);
    // Fetch Questions
    const { data, error } = useFetch(url + new URLSearchParams(params), {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'X-WP-Nonce': window.mainSiteData.nonce
        }
    });
    // Update questions
    useEffect(() => {
        setLoading(true);
        if (error || !data)
            return;
        dispatch({
            type: SET_QUESTIONS,
            questions: data
        });
        setTimeout(() => {
            setLoading(false);
        }, 300);
    }, [data, error, setLoading]);
    return (_jsxs(_Fragment, { children: [_jsx(IconSprite, {}), loading ? (_jsx("div", { className: "loading" })) : (_jsx("section", { children: _jsxs(SwiperContainer, { className: "trip-builder", slidesPerView: 1, allowTouchMove: false, modules: [Navigation, Pagination], pagination: {
                        el: '.swiper-pagination',
                        // .swiper-pagination-bullet-active
                        renderBullet: (index, className) => {
                            return `<span class="w-10 h-10 flex items-center justify-center ${index > slideIndex ? 'border-grey-200 text-grey-200' : 'border-gold text-white bg-gold'} border-2 font-semibold leading-tighter transition-all duration-300 tablet-landscape:w-12 tablet-landscape:h-12 ${className}">${(index + 1)}</span>`;
                        }
                    }, onRealIndexChange: (swiper) => setSlideIndex(swiper.realIndex), children: [state.questions.map((question, i) => (_jsx(SwiperSlide, { children: _jsx(Question, { question: question, questionNumber: i + 1 }) }, question.id))), _jsx(TripBuilderFooter, {})] }) }))] }));
};
export default TripBuilder;
